type CaptionImageProps = {
  children: React.ReactNode;
};

export default function CaptionImage({ children }: CaptionImageProps) {
  return (
    <span
      className="absolute bg-teal-40 bottom-0 right-0 text-white px-2.5 py-1 rounded-br-lg rounded-tl-lg"
      data-testid="caption-image"
    >
      {children}
    </span>
  );
}
